import { useMediaPreviewContext } from "./MediaPreviewContext";
import { PreviewImage } from "./styledComponents";

interface IMediaPreviewImageProps {
    src: string;
    /** Optional "WxH" string for native width/height attributes */
    dimensions?: string | null;
    onError?: () => void;
}

export const MediaPreviewImage = ({ src, dimensions, onError }: IMediaPreviewImageProps) => {
    const { state, actions } = useMediaPreviewContext();

    const [width, height] = dimensions?.split("x") ?? [];

    const handleLoad = () => {
        actions.setLoaded();
    };

    const handleError = () => {
        actions.setError();
        onError?.();
    };

    return (
        <PreviewImage
            key={src}
            src={src}
            width={width}
            height={height}
            onLoad={handleLoad}
            onError={handleError}
            style={{ display: state.status === "loaded" ? "block" : "none" }}
            alt="Media preview"
            data-automation="media-preview-image"
        />
    );
};
